import { ConsumerExperimentsConfigs } from './clientExperiments';

export const clientExperimentsConfig: ConsumerExperimentsConfigs = [
    /* Please don't erase - Example config
    {
        experimentId: HAWKS_CHECKOUT_DRAWER_VARIATIONS,
        rolloutName: ROLLOUTS.HAWKS_DRAWER_VARIATIONS_GRADUAL,
        experimentType: EXPERIMENT_TYPE.USER,
        numOfGroups: 3,
        isEligible: (propsForEligibility: Record<string, any>) =>
            isLoggedInUser() && isPackageValidForCheckoutDrawer(propsForEligibility.store)
    }, */
    // Checkout Test (Milestones + Subscriptions + Calculators) w/ Extras
];
